export default __webpack_public_path__ + "static/media/VideoCall.d90d874e.svg";